import React, { useEffect } from 'react';

import { Heading1, Paragraph } from '@sopranodesign/pulse-components';
import { useQuerySearch, useQuery } from '@sopranodesign/pulse-hooks';

import {
  AnimatedAuthContainer,
  LoggedInRedirect,
  AuthErrorRedirect
} from '../../../Components/index';
import { useAuth } from '../../../hooks/index';

const OAuthCallback = ({ location }) => {
  const code = useQuerySearch(location, 'code');

  const { authenticated, loginUser } = useAuth();

  const { data, isError, isSuccess } = useQuery({
    queryKey: [`auth/oauth2/callback${location.search}`],
    enabled: Boolean(code && !authenticated)
  });

  useEffect(() => {
    if (isSuccess) {
      const { token, client, ...user } = data.data;
      loginUser({ user, token, client });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isSuccess]);

  if (authenticated) {
    return <LoggedInRedirect />;
  }

  if (!code || isError) {
    return <AuthErrorRedirect />;
  }

  return (
    <AnimatedAuthContainer>
      <Heading1 style={{ fontSize: '2rem' }} mb textCenter>
        Logging you in
      </Heading1>
      <Paragraph mb secondary textCenter>
        Please wait and you will be automatically logged in
      </Paragraph>
    </AnimatedAuthContainer>
  );
};

export default OAuthCallback;
